import { Box, Button, Divider, List, ListItem, ListItemText, Modal, Typography } from '@mui/material';
import { FC } from 'react';
import { DriverScoreTooltipLabel } from '../../utils/types/tooltip';
import { DRIVER_SCORE_TOOLTIP_CONTENT } from '../../utils/constants/toolTipContent';

const DriverScoreModal: FC<{ open: boolean; onClose: () => void; label: string }> = ({ open, onClose, label }) => {
	const content = DRIVER_SCORE_TOOLTIP_CONTENT[label.toLowerCase() as DriverScoreTooltipLabel];

	if (!content) return null;

	return (
		<Modal aria-labelledby={`driver-score-modal-${label}`} open={open} onClose={onClose}>
			<Box
				sx={(theme) => ({
					position: 'absolute',
					top: '50%',
					left: '50%',
					borderRadius: 4,
					transform: 'translate(-50%, -50%)',
					width: '35%',
					bgcolor: 'background.paper',
					boxShadow: 24,
					overflow: 'hidden',
					border: `2px solid ${theme.palette.grey[300]}`,
					[theme.breakpoints.down('md')]: {
						width: '90%',
					},
				})}
			>
				<Box
					sx={{
						py: 1,
						px: 2,
					}}
				>
					<Typography sx={{ color: 'primary.main' }} id='helper-modal-modal-title' variant='h6' component='h2'>
						{content.title}
					</Typography>
				</Box>
				<Divider />
				<Box
					sx={{
						py: 2,
						px: 2,
						overflowY: 'auto',
						maxHeight: '500px',
						overflowX: 'hidden',
					}}
				>
					<Typography
						id='helper-modal-modal-description'
						sx={{
							'& a': {
								overflowWrap: 'break-word',
							},
							'& .sub-paragraph': {
								display: 'inline-block',
								marginBottom: '1em',
							},
						}}
					>
						{content.description}
					</Typography>
					{/* Bulleted list of improvement tips */}
					<Typography variant='body1' component='h2' sx={{ fontWeight: 900, pt: 1 }}>
						Tips to Improve
					</Typography>
					<List component='ul' sx={{ listStyleType: 'disc', pl: 1 }}>
						{content.tips.map((tip: string, index: number) => (
							<ListItem component='li' key={`${label}-tip-${index}`} sx={{ py: 0 }}>
								<ListItemText
									id={`${label}-tip-${index}`}
									sx={{ display: 'list-item' }}
									primary={
										<Typography
											id={`helper-modal-modal-tip-${index}`}
											variant='body1'
											sx={{
												'& a': {
													overflowWrap: 'break-word',
												},
												'& .sub-paragraph': {
													display: 'inline-block',
													marginBottom: '1em',
												},
											}}
										>
											{tip}
										</Typography>
									}
								/>
							</ListItem>
						))}
					</List>
				</Box>
				{/* Main description text */}
				<Divider />
				<Box
					sx={{
						py: 1,
						px: 2,
						display: 'flex',
						flexDirection: 'row-reverse',
					}}
				>
					<Button variant='contained' color='primary' onClick={onClose} sx={{ mt: 2 }}>
						Got it
					</Button>
				</Box>
			</Box>
		</Modal>
	);
};

export default DriverScoreModal;
